module.exports = __webpack_public_path__ + "static/media/Cecil-profile-icon.22ec5828.png";